import { useEffect, useState } from "react";

type LinkDialogProps = {
    isOpen: boolean;
    onClose: () => void;
    onSave: (url: string, title: string) => void;
    url: string;
    title: string;
    setUrl: React.Dispatch<React.SetStateAction<string>>;
    setTitle: React.Dispatch<React.SetStateAction<string>>;
};

export const TipTapLinkDialog = ({
    isOpen,
    onClose,
    onSave,
    url,
    title,
    setTitle,
    setUrl,
}: LinkDialogProps) => {
    const [isValid, setIsValid] = useState(true);
    const validateUrl = (value: string) => {
        const pattern = new RegExp(
            "^(https?:\\/\\/)?" +
                "((([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)+[a-zA-Z]{2,}|" +
                "localhost|" +
                "\\d{1,3}(\\.\\d{1,3}){3})" +
                "(\\:\\d+)?(\\/[-a-zA-Z\\d%_.~+]*)*" +
                "(\\?[;&a-zA-Z\\d%_.~+=-]*)?" +
                "(\\#[-a-zA-Z\\d_]*)?$",
            "i",
        );
        return !!pattern.test(value);
    };

    const handleSave = () => {
        const finalUrl =
            url.startsWith("http://") || url.startsWith("https://") ? url : `https://${url}`;
        const validURL = validateUrl(finalUrl);
        setIsValid(validURL);

        if (!validURL) return;

        onSave(finalUrl, title);
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="w-96 rounded-lg bg-white p-6 shadow-lg">
                <h3 className="mb-3 text-lg font-semibold">Insert Link</h3>

                <label className="mb-2 block">URL</label>
                <input
                    type="text"
                    className=" w-full rounded border p-2"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    placeholder="Enter URL"
                />
                {!isValid && <p className="text-sm text-red-500">Please enter a valid URL.</p>}

                <label className="mb-2 mt-4 block">Title (optional)</label>
                <input
                    type="text"
                    className="mb-4 w-full rounded border p-2"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Enter Title"
                />

                <div className="flex justify-end gap-2">
                    <button
                        onClick={onClose}
                        className="rounded bg-gray-300 px-4 py-2 hover:bg-gray-400"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSave}
                        className="rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
                    >
                        Insert
                    </button>
                </div>
            </div>
        </div>
    );
};
